/**
 * This component represents an individual item in the multi-select drop-down
 */
import React, { useRef } from 'react';
import { useKey } from '../hooks/UseKey';
import { KEY } from '../lib/constants';
import DefaultItemRenderer from './DefaultItem';
var SelectItem = function (_a) {
    var _b = _a.itemRenderer, ItemRenderer = _b === void 0 ? DefaultItemRenderer : _b, option = _a.option, checked = _a.checked, tabIndex = _a.tabIndex, disabled = _a.disabled, onSelectionChanged = _a.onSelectionChanged, onClick = _a.onClick;
    var itemRef = useRef();
    var onOptionCheck = function (e) {
        toggleChecked();
        e.preventDefault();
    };
    var toggleChecked = function () {
        if (!disabled) {
            onSelectionChanged(!checked);
        }
    };
    var handleClick = function (e) {
        toggleChecked();
        onClick(e);
    };
    useKey([KEY.ENTER, KEY.SPACE], onOptionCheck, { target: itemRef });
    return (React.createElement("label", { className: "select-item ".concat(checked && 'selected'), role: "option", "aria-selected": checked, tabIndex: tabIndex, ref: itemRef },
        React.createElement(ItemRenderer, { option: option, checked: checked, onClick: handleClick, disabled: disabled })));
};
export default SelectItem;



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/select-panel/SelectItem.tsx
// module id = 264
// module chunks = 0